import { render, staticRenderFns } from "./erp-table.vue?vue&type=template&id=e00192d6&"
import script from "./erp-table.vue?vue&type=script&lang=js&"
export * from "./erp-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports